import React, { useState, useRef, useMemo, useCallback } from 'react';
import { Button } from 'react-bootstrap';

import Table from 'components/common/Table';
import CreateShelfModal from 'components/admin/shelf/CreateShelfModal';
import TransferShelfModal from 'components/admin/shelf/TransferShelfModal';

import { adminShelfApi } from 'api';
import { useUserContext } from 'providers/UserProvider';

import {
  ADMIN_SHELF_LIST_TAB,
  getAdminShelfListColumns,
  ADMIN_SHELF_FILTER_OPTIONS,
} from 'constants/admin/shelf';

const Shelf = () => {
  const tableRef = useRef();
  const [showCreateShelfModal, setShowCreateShelfModal] = useState(false);
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [transferSourceShelf, setTransferSourceShelf] = useState(null);
  const { selectedTenant, selectedWarehouse } = useUserContext();

  const tenant = selectedTenant?.domains?.[0]?.domain;
  const warehouse = selectedWarehouse?.domain;

  const handleTransferClick = useCallback(shelf => {
    setTransferSourceShelf(shelf);
    setShowTransferModal(true);
  }, []);

  const columns = useMemo(() => {
    return getAdminShelfListColumns(tenant, warehouse, handleTransferClick);
  }, [tenant, warehouse, handleTransferClick]);

  const headerActions = (
    <Button
      variant="primary"
      size="sm"
      onClick={() => setShowCreateShelfModal(true)}
    >
      Create Shelf
    </Button>
  );

  const exportApi = useCallback(params => {
    return adminShelfApi.exportShelf(params);
  }, []);

  const handleActionSuccess = () => {
    tableRef.current?.refetch();
  };

  return (
    <>
      <Table
        ref={tableRef}
        title="Shelf"
        apiService={adminShelfApi}
        exportApi={exportApi}
        sortable={true}
        columns={columns} // Use the memoized columns
        filterOptions={ADMIN_SHELF_FILTER_OPTIONS}
        tabOptions={ADMIN_SHELF_LIST_TAB}
        headerActions={headerActions}
      />

      <CreateShelfModal
        show={showCreateShelfModal}
        onHide={() => setShowCreateShelfModal(false)}
        onSuccess={handleActionSuccess}
      />

      <TransferShelfModal
        show={showTransferModal}
        onHide={() => setShowTransferModal(false)}
        onSuccess={handleActionSuccess}
        sourceShelf={transferSourceShelf}
      />
    </>
  );
};

export default Shelf;
